"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AntiDesertificationTechniques = void 0;
const CardName_1 = require("../../CardName");
const CardRenderer_1 = require("../render/CardRenderer");
const Resources_1 = require("../../Resources");
const PreludeCard_1 = require("../prelude/PreludeCard");
const Tags_1 = require("../Tags");
class AntiDesertificationTechniques extends PreludeCard_1.PreludeCard {
    constructor() {
        super({
            name: CardName_1.CardName.ANTI_DESERTIFICATION_TECHNIQUES,
            tags: [Tags_1.Tags.MICROBE, Tags_1.Tags.PLANT],
            metadata: {
                cardNumber: 'X49',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.production((pb) => pb.plants(1).steel(1));
                    b.megacredits(3);
                }),
                description: 'Increase your plant and steel production 1 step each. Gain 3 M€.',
            },
        });
    }
    play(player) {
        player.addProduction(Resources_1.Resources.STEEL, 1);
        player.addProduction(Resources_1.Resources.PLANTS, 1);
        player.addResource(Resources_1.Resources.MEGACREDITS, 3);
        return undefined;
    }
}
exports.AntiDesertificationTechniques = AntiDesertificationTechniques;
//# sourceMappingURL=AntiDesertificationTechniques.js.map